import React from 'react';
import { ArrowRight } from 'lucide-react';
interface AdvisoryFinalCTAProps {
  openContactForm: () => void;
}
export function AdvisoryFinalCTA({
  openContactForm
}: AdvisoryFinalCTAProps) {
  return <section className="w-full py-28 sm:py-36 px-6 sm:px-8 bg-navy-900 relative overflow-hidden" data-id="element-50">
      {/* Background elements */}
      <div className="absolute inset-0" data-id="element-51">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-gold-500/50 to-transparent" data-id="element-52" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl" data-id="element-53" />
        <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl" data-id="element-54" />
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-55">
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-serif text-white mb-6 leading-tight" data-id="element-56">
          Stop guessing.
          <br data-id="element-57" />
          Start scaling.
        </h2>

        <p className="text-slate-400 text-lg sm:text-xl mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-58">
          A quick, high-value conversation to identify the "hidden" cash in your
          operations. No pitch, no pressure—just one actionable insight you can
          use immediately.
        </p>

        <a href="https://calendar.app.google/QG1eQrZMQfAuXDhF8" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center bg-gold-500 text-navy-900 px-10 py-5 font-semibold rounded hover:bg-gold-400 transition-all duration-300 text-[16px]" data-id="element-59">
          Schedule Your Free Discovery Call Today
          <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-60" />
        </a>
      </div>
    </section>;
}